(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oath-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.oath-reviews__card--video').forEach(function (card) {
    card.addEventListener('click', function () {
      var video = card.querySelector('video');
      if (!video) return;
      video.muted = !video.muted;
      card.classList.toggle('is-unmuted', !video.muted);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oath-statement-move"] && !Shopify.designMode) return;
  try {
    
const image = document.querySelector('.statement_image');
const text = document.querySelector('.statement_text');
const statement_image = document.querySelector('.oath-statement-text-image');

function animate() {
  image.classList.add('active');
  text.classList.add('active');
  statement_image.classList.add('in-active');

  setTimeout(() => {
    image.classList.remove('active');
    text.classList.remove('active');
  }, 3000);
  
  setTimeout(() => {
    statement_image.classList.remove('in-active');
  }, 3500);
}

animate();
setInterval(animate, 5000);

  } catch(e) { console.error(e); }
})();
})();
